import React, { useContext } from "react";
import withStyles from "../../common/wrappers/withStyles";

const BellPlain = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
    >
      <path
        fill={color}
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        d="M11.5 24.375c-.907 0-1.643-.73-1.643-1.627H8.214C8.214 24.542 9.69 26 11.5 26s3.286-1.458 3.286-3.252h-1.643c0 .897-.736 1.627-1.643 1.627zm10.75-7.373c-1.436-1.352-2.534-2.766-2.534-7.562 0-4.041-3.254-7.338-7.395-7.736V.813a.817.817 0 00-.82-.813.817.817 0 00-.822.813v.891C6.539 2.103 3.284 5.4 3.284 9.44c0 4.795-1.098 6.21-2.534 7.562a2.345 2.345 0 00-.577 2.602 2.45 2.45 0 002.291 1.521h18.072a2.45 2.45 0 002.291-1.522 2.345 2.345 0 00-.578-2.6zM20.535 19.5H2.464c-.73 0-1.095-.836-.58-1.32 1.789-1.686 3.043-3.573 3.043-8.74 0-3.42 2.94-6.19 6.573-6.19 3.633 0 6.573 2.769 6.573 6.19 0 5.147 1.243 7.044 3.044 8.739.516.487.146 1.321-.581 1.321z"
        transform="translate(-41 -435) translate(41 90) translate(0 288) translate(0 57)"
      />
    </svg>
  );
};

function Bell({ color }) {
  return (
    <>
      <BellPlain color={color} />
    </>
  );
}

Bell.defaultProps = {
  color: "white",
};

export default withStyles(Bell);
